import { Table } from 'antd';
import TcCoverLoading from 'components/UI/TcLoading/TcCoverLoading';
import { inqueryLocker, pudoBranch } from 'global/Models/lockerModel';
import { lockerInfo } from 'global/Models/omOrderModel';
import { FC } from 'react';
import { useDispatch } from 'react-redux';
import { setOmOrderReservedByLocker } from 'redux/reducer/ParcelOrder/parcelOrderReducer';

interface Props {
  loading: boolean;
  pudoBranchesList: pudoBranch[];
  setLockerAddress?: (_locker: lockerInfo) => void;
  cityId?: number;
  handleClose: () => void;
}

const OrderSelectPudoListTab: FC<Props> = ({ pudoBranchesList, loading, setLockerAddress, cityId, handleClose }) => {
  const dispatch = useDispatch();

  const handleSelectPudo = (pudo: pudoBranch) => {
    if (!cityId) return;
    dispatch(setOmOrderReservedByLocker(undefined));
    setLockerAddress &&
      setLockerAddress({
        orderNumber: '',
        locker: {} as inqueryLocker,
        cityId,
        pudoId: pudo.id,
      });

    handleClose();
  };

  const columns = [
    {
      title: 'عنوان',
      key: 'title',
      dataIndex: 'title',
    },
    {
      title: 'شهر',
      key: 'cityTitle',
      dataIndex: 'cityTitle',
    },
    {
      title: 'استان',
      key: 'provinceTitle',
      dataIndex: 'provinceTitle',
    },
    {
      title: 'آدرس',
      key: 'address',
      dataIndex: 'address',
      render: (_text: string, record: pudoBranch) => record.address?.fullAddress || '-',
    },
    {
      title: 'انتخاب پودو',
      key: 'select',
      dataIndex: 'select',
      render: (_text: string, record: pudoBranch) => (
        <span className='cursor-pointer text-t-secondary-color hover:underline' onClick={() => handleSelectPudo(record)}>
          انتخاب
        </span>
      ),
    },
  ];

  return (
    <>
      <div className='mt-5'>
        <Table
          dataSource={pudoBranchesList}
          columns={columns}
          pagination={{
            pageSize: 20,
            total: pudoBranchesList.length,
          }}
          rowKey='id'
        />
      </div>
      {loading && <TcCoverLoading />}
    </>
  );
};

export default OrderSelectPudoListTab;
